import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PedidoReferenciaDataPipeModule } from '../pipes';

import { PedidoReferenciaDataSelectComponent } from './pedido-referencia-data-select.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoReferenciaDataPipeModule
    ],
    declarations: [
        PedidoReferenciaDataSelectComponent
    ],
    exports: [
        PedidoReferenciaDataSelectComponent
    ]
})
export class PedidoReferenciaDataSelectModule { }
